import React from 'react'
import "../styles/Misvis.css"
import { useLanguage } from "../contexts/LanguageContext";

const MisVis = () => {
  const { language } = useLanguage();

  const content = {
    purposeTitle: {
      english: "Our Purpose",
      tamil: "எங்கள் நோக்கம்"
    },
    missionVision: {
      english: "Mission & Vision",
      tamil: "குறிக்கோள் & பார்வை"
    },
    purposeSubtitle: {
      english: "To build a strong, prosperous, and inclusive India that empowers every citizen and reclaims its rightful place as a global leader (Vishwa Guru).",
      tamil: "வலுவான, வளமான மற்றும் அனைவரையும் உள்ளடக்கிய இந்தியாவை உருவாக்கி, ஒவ்வொரு குடிமகனுக்கும் சம வாய்ப்புகளை வழங்குதல்."
    },
    missionTitle: {
      english: "Our Mission",
      tamil: "எங்கள் குறிக்கோள்"
    },
    visionTitle: {
      english: "Our Vision for India",
      tamil: "இந்தியாவிற்கான எங்கள் பார்வை"
    },
    visionDescription: {
      english: "We envision an India that is modern yet deeply rooted in its cultural values. An India where women are empowered, healthcare awareness is widespread, entrepreneurship is encouraged, and every citizen contributes meaningfully to national development.",
      tamil: "நவீனமான ஆனால் கலாச்சார மதிப்புகளில் ஆழமாக வேரூன்றிய இந்தியாவை நாங்கள் காண்கிறோம். ஒரு இந்தியா, பெண்கள் அதிகாரம் பெற்ற, சுகாதார விழிப்புணர்வு பரவலான, தொழில்முனைவு ஊக்குவிக்கப்பட்ட, மற்றும் ஒவ்வொரு குடிமகனும் தேசிய வளர்ச்சிக்கு அர்த்தமுள்ள பங்களிப்பை வழங்கும்."
    },
    coreValues: {
      english: "Core Values",
      tamil: "முக்கிய மதிப்புகள்"
    }
  };

  const visionPoints = {
    english: [
      "Economically Strong & Self-Reliant Nation",
      "Socially Inclusive & Women-Empowered Society",
      "Global Leader in Peace, Culture & Development"
    ],
    tamil: [
      "பொருளாதார ரீதியாக வலுவான மற்றும் சுயாதீனமான நாடு",
      "சமூக ரீதியாக அனைவரையும் உள்ளடக்கிய மற்றும் பெண்கள் அதிகாரம் பெற்ற சமூகம்",
      "சமாதானம், கலாச்சாரம் மற்றும் வளர்ச்சியில் உலகத் தலைவர்"
    ]
  };

  const missionData = [
    {
      icon: "/assets/sudha-bjp/flag.png",
      title: {
        english: "Nation First",
        tamil: "தேசம் முதலில்"
      },
      desc: {
        english: "Placing the interests of the nation above personal or political gains, ensuring unity, integrity, and long-term national development.",
        tamil: "தனிப்பட்ட அல்லது அரசியல் நலன்களை விட தேசிய நலன்களை முன்னிலைப்படுத்துதல், ஒற்றுமை, நேர்மை மற்றும் நீண்டகால தேசிய வளர்ச்சியை உறுதி செய்தல்."
      }
    },
    {
      icon: "/assets/sudha-bjp/love.png",
      title: {
        english: "People-Centric Development",
        tamil: "மக்கள் மையமான வளர்ச்சி"
      },
      desc: {
        english: "Inclusive development that reaches women, minorities, small-scale workers, and the last person in society (Antyodaya).",
        tamil: "பெண்கள், சிறுபான்மையினர், குறுந்தொழிலாளர்கள் மற்றும் சமூகத்தின் கடைசி நபர் வரை (அந்தியோதயா) செல்லும் அனைவரையும் உள்ளடக்கிய வளர்ச்சி."
      }
    },
    {
      icon: "/assets/sudha-bjp/shield1.png",
      title: {
        english: "Transparent & Responsible Governance",
        tamil: "வெளிப்படையான மற்றும் பொறுப்பான நிர்வாகம்"
      },
      desc: {
        english: "Corruption-free administration focused on accountability, efficiency, and trust-building among citizens.",
        tamil: "குடிமக்களிடையே பொறுப்புணர்வு, திறமை மற்றும் நம்பிக்கை உருவாக்கத்தில் கவனம் செலுத்தும் ஊழல் இல்லாத நிர்வாகம்."
      }
    }
  ];

  const values = [
    {
      title: {
        english: "Nationalism",
        tamil: "தேசபக்தி"
      },
      icon: "/assets/sudha-bjp/flag.png",
    },
    {
      title: {
        english: "Integrity",
        tamil: "நேர்மை"
      },
      icon: "/assets/sudha-bjp/shield1.png",
    },
    {
      title: {
        english: "Leadership & Service",
        tamil: "தலைமைத்துவம் மற்றும் சேவை"
      },
      icon: "/assets/sudha-bjp/leader.png",
    },
    {
      title: {
        english: "Cultural Heritage",
        tamil: "கலாசார பாரம்பரியம்"
      },
      icon: "/assets/sudha-bjp/love.png",
    }
  ];

  const visionItems = [
    {
      icon: "/assets/sudha-bjp/point.png",
      title: {
        english: "Viksit Bharat 2047",
        tamil: "விக்ஸிட் பாரத் 2047"
      },
      desc: {
        english: "Building a fully developed India by 2047 through economic growth, social justice, and empowered citizens.",
        tamil: "பொருளாதார வளர்ச்சி, சமூக நீதி மற்றும் அதிகாரம் பெற்ற குடிமக்கள் மூலம் 2047க்குள் முழுமையாக வளர்ந்த இந்தியாவை கட்டியெழுப்புதல்."
      }
    },
    {
      icon: "/assets/sudha-bjp/eye.png",
      title: {
        english: "Atmanirbhar Bharat",
        tamil: "அத்மநிர்பார் பாரத்"
      },
      desc: {
        english: "A self-reliant India with strong entrepreneurship, healthcare awareness, women empowerment, and local industries.",
        tamil: "வலுவான தொழில்முனைவு, சுகாதார விழிப்புணர்வு, பெண்கள் அதிகாரமளிப்பு மற்றும் உள்ளூர் தொழில்களுடன் சுயாதீனமான இந்தியா."
      }
    }
  ];

  return (
    <div>
      {/* PURPOSE */}
      <section className='misvismain'>
        <h1 className='misvismain1'>{content.purposeTitle[language]}</h1>
        <h1 className='misvismain2'>{content.missionVision[language]}</h1>
        <h2 className='misvismain3'>
          {content.purposeSubtitle[language]}
        </h2>
      </section>

      {/* MISSION */}
      <section className="mission-section">
        <div className="mission-header">
          <h2>{content.missionTitle[language]}</h2>
        </div>

        <div className="mission-cards">
          {missionData.map((item, index) => (
            <div className="mission-card" key={index}>
              <div className="icon-circle"><img src={item.icon} alt="" /></div>
              <h3>{item.title[language]}</h3>
              <p className="desc">{item.desc[language]}</p>
            </div>
          ))}
        </div>
      </section>

      {/* VISION */}
      <section className="vision-section">
        <div className="vision-container">
          {/* LEFT CARD */}
          <div className="vision-card">
            {visionItems.map((item, index) => (
              <div className="vision-item" key={index}>
                <div className="vision-icon"><img src={item.icon} alt="" /></div>
                <div>
                  <h4>{item.title[language]}</h4>
                  <p>{item.desc[language]}</p>
                </div>
              </div>
            ))}
            <span className="vision-bg-circle"></span>
          </div>

          {/* RIGHT CONTENT */}
          <div className="vision-content">
            <h2>{content.visionTitle[language]}</h2>
            <p className="desc">
              {content.visionDescription[language]}
            </p>

            <ul className="vision-list">
              {visionPoints[language].map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="core-section">
        <div className="core-header">
          <h2>{content.coreValues[language]}</h2>
        </div>

        <div className="core-cards">
          {values.map((item, index) => (
            <div className="core-card" key={index}>
              <div className="core-icon"><img src={item.icon} alt="" /></div>
              <h4>{item.title[language]}</h4>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default MisVis